import style from './style.css';

const HorizontalScroll = (props) => {
  return (
    <div className={style.horizontalScrollContainer}>{props.children}</div>
  );
};

export default HorizontalScroll;



// WEBPACK FOOTER //
// ./componentsBICRevamp/common/horizontalScroll/index.js